import React from 'react';
import { Outlet } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import { useMediaQuery, AppBar, Box, Toolbar } from '@mui/material';
import { drawerWidth } from '../../config';
import Header from './Header';
import Sidebar from './Sidebar';
import { useIsAuthenticated } from "@azure/msal-react";
// import { useOktaAuth } from '@okta/okta-react';

const Main = styled((props) => <main {...props} />)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  [theme.breakpoints.up('md')]: {
    marginLeft: -drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`
  }
}));

const OutletDiv = styled((props) => <div {...props} />)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3)
  },
  padding: theme.spacing(5)
}));


const MainLayout = () => {
  // const { authState } = useOktaAuth();
  const theme = useTheme();
  const isAuthenticated  = useIsAuthenticated();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  React.useEffect(() => {
    setDrawerOpen(matchUpMd);
  }, [matchUpMd]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
    {/* { authState?.isAuthenticated && */}
      {/* {isAuthenticated && */}
      <><AppBar position="fixed" sx={{ zIndex: 1200 }}>
          <Toolbar>
            <Header drawerOpen={drawerOpen} drawerToggle={handleDrawerToggle} />
          </Toolbar>
        </AppBar><Sidebar drawerOpen={drawerOpen} drawerToggle={handleDrawerToggle} /></>
      {/* } */}
      {/* } */}
      <Main
        style={{
          ...(drawerOpen && {
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen
            }),
            marginLeft: 0,
            marginRight: 'inherit'
          })
        }}
        sx={{ backgroundColor: '#F4F5F7' }}
      >
        <Box sx={theme.mixins.toolbar} />
        <OutletDiv>
          <Outlet />
        </OutletDiv>
      </Main>
    </Box>
  );
};

export default MainLayout;
